<app-header></app-header>
<section class="inerpages-banner">
    <img src="assets/img/shish-page-bg.jpg" class="w-100" alt="">
    <div class="fade-bg"></div>
    <div class="mask-content-v-center text-center">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="tbox-iner text-center animate zoomIn" data-anim-type="zoomIn">
                        <div class="heading-iner">
                            <h2> Shisha</h2>
                            <hr>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="py-5 sisha-page">
  <div class="container">
     <div class="row">
         
        <div class="col-sm-6 img-sec">
            <img src="assets/img/shish-img.jpg" class="img-fluid img-bdr" />
        </div>
<div class="col-sm-6">
    <h5>Only in Tourist Club Branch</h5>
    <p>Now you can have your favorit falover Shisha while dinning in at Sajway. Our shisha is made with the best tobacco
    moassal from Al-Fakher brand, our shishas are cleaned and sanitized after every use for your maximum safety, service is
    around the clock to make sure your charcoal is always ready and your shisha is fired up.</p>
    <p>
        The shisha is served all day long during opening hours in its designated and well ventilated area by the lounge windows
        that over look the main street. To make sure that your place is reserved, you can now book your table online prior to
        arrival. We look forward to welcoming you in our shisha lounge.
    </p>

    <a routerLink="/reserve" class="btn mt-4 btn-booknow">Book now</a>
</div>

     </div>

  </div>
</section>


                               